/* eslint-disable array-callback-return */
/* eslint-disable no-useless-rename */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-template-curly-in-string */

//ran this thru claudes code refactoring tool

//move byThePan to overlay the image on the top of the image


// suggest improvements for this component
// give the entire code to copy

// redesign this component to look more elegant and polished and accents
// make sure each card is the same height
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task

// do not change any functionality
// use tailwind css in the className directive 
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.

// ask me a series of questions to gather additional context you need to best achive this task
// Give me the complete code with instructions


// make Action buttons — row align with the bottom of the card 
// give me the relevant code




import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaTrash } from "react-icons/fa6";
import { TbArrowBigRightLinesFilled } from "react-icons/tb";
import { currencyFormat } from './CurrencyFormat';
import { delete_cart_product } from '../store/reducers/cartReducer';
import SkeletonWithImage from './SkeletonWithImage';
import GetSellerConfig from '../components/GetSellerConfig';
import config from '../config';

const CartProduct = ({
    pt,
    onQuantityIncrement,
    onQuantityDecrement,
    onPortionSizeChange,
    onEventPartChange,
    onMoveToWishlist,
}) => {
    const dispatch = useDispatch();
    const sellerShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;

    const {
        sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight,
        sellerEventParts, sellerBoolShowSitePayments, sellerBoolShowQuantities
    } = GetSellerConfig();

    const colors = React.useMemo(() => ({
        border: sellerPrimaryColor1 + sellerColorSuffixDark,
        text: sellerPrimaryColor1 + sellerColorSuffixDark,
        bg: sellerPrimaryColor1 + sellerColorSuffixLight,
    }), [sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight]);

    const hasPanLabel = pt?.productInfo?.byThePan !== 'NoPan';
    const imageSrc = pt?.productInfo?.images?.[0];
    const imageSizeStyle = { width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' };

    return (
        <div
            className='rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden border'
            style={{
                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                borderLeft: `6px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}`,
                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
            }}>

            <div className='flex min-h-[260px] h-full'>

                {/* Accent stripe */}
                <div
                    className='hidden w-1.5 sm:w-2 shrink-0'
                    style={{ backgroundColor: colors.border }}
                    aria-hidden='true'
                />

                {/* Card content — justify-between splits top content from buttons */}
                <div
                    className='flex-1 p-3 flex flex-col justify-between gap-2'
                    style={{ color: colors.text }}>

                    {/* TOP GROUP — everything except action buttons */}
                    <div className='flex flex-col gap-2.5'>

                        {/* Name + category + eventPart badge + byThePan */}
                        <div className='flex flex-wrap items-start justify-between gap-1.5'>
                            <div className='text-sm font-semibold leading-snug min-w-0 flex-1 tracking-tight'>
                                <div>{pt?.productInfo?.name}</div>
                                <div className='font-normal opacity-60'>{pt?.productInfo?.category}</div>
                                {pt?.eventPart && (
                                    <span
                                        className='font-medium opacity-80 ml-1 px-2 py-0.5 rounded-full border text-[11px] shrink-0 inline-block'
                                        style={{ borderColor: colors.border }}>
                                        {pt.eventPart}
                                    </span>
                                )}
                            </div>
                            {hasPanLabel && (
                                <div className='hidden sm:block'>
                                    <div
                                        className='border text-[11px] font-medium px-2.5 py-0.5 flex flex-wrap justify-center
                                        items-center rounded-md shrink-0 whitespace-nowrap shadow-sm'
                                        style={{ borderColor: colors.border, backgroundColor: 'white' }}>
                                        <span>{pt.productInfo.byThePan}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Main row: image + controls */}
                        <div className='flex flex-wrap gap-3'>

                            {/* Image */}
                            <div
                                className='shrink-0 overflow-hidden relative rounded-lg ring-1 ring-black/5 shadow-sm'
                                style={imageSizeStyle}>
                                <SkeletonWithImage
                                    src={imageSrc}
                                    alt={pt?.productInfo?.name}
                                    className='rounded-lg object-cover'
                                    style={imageSizeStyle}
                                />
                                {hasPanLabel && (
                                    <div
                                        className='sm:hidden absolute top-1.5 left-1 text-[10px] font-medium px-0.5 py-0.5 w-[88%] flex flex-wrap
                                        justify-center items-center border rounded-md shrink-0 shadow-sm'
                                        style={{ borderColor: colors.border, backgroundColor: 'white', color: colors.text }}>
                                        {pt.productInfo.byThePan}
                                    </div>
                                )}
                                {sellerShowBrand && (
                                    <div
                                        className='text-[11px] mt-1 opacity-60 truncate font-medium'
                                        style={{ maxWidth: 'clamp(80px, 20vw, 150px)' }}>
                                        {pt.productInfo.brand}
                                    </div>
                                )}
                            </div>

                            {/* Controls */}
                            <div className='flex flex-col gap-2 flex-1 min-w-[120px]'>

                                {/* Price */}
                                {sellerBoolShowSitePayments && (
                                    <div className='text-base font-bold tracking-tight' style={{ color: colors.text }}>
                                        {currencyFormat.format(pt.productInfo.price)}
                                    </div>
                                )}

                                {/* Quantity stepper */}
                                {sellerBoolShowQuantities && (
                                    <div
                                        className='flex h-8 w-full max-w-[160px] border rounded-lg justify-center items-center text-sm font-semibold select-none shadow-sm overflow-hidden'
                                        style={{
                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
                                        }}>
                                        <button
                                            onClick={() => onQuantityDecrement(pt.quantity, pt._id)}
                                            disabled={pt.quantity <= 1}
                                            className='flex-1 h-full flex items-center justify-center cursor-pointer hover:bg-black/5 active:bg-black/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed'
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                            aria-label='Decrease quantity'
                                        >−</button>
                                        <div
                                            className='px-3 border-x font-semibold'
                                            style={{
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark
                                            }}>
                                            {pt.quantity}
                                        </div>
                                        <button
                                            onClick={() => onQuantityIncrement(pt.quantity, pt.productInfo.stock, pt._id)}
                                            disabled={pt.quantity >= pt.productInfo.stock}
                                            className='flex-1 h-full flex items-center justify-center cursor-pointer hover:bg-black/5 active:bg-black/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed'
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                            aria-label='Increase quantity'
                                        >+</button>
                                    </div>
                                )}

                                {/* Event Part selector */}
                                {sellerEventParts && sellerEventParts !== '' && (
                                    <select
                                        value={pt.eventPart ?? ''}
                                        onChange={(e) => onEventPartChange(pt._id, e.target.value)}
                                        aria-label='Choose event part'
                                        className='text-[12px] h-8 w-full max-w-[160px] px-2 rounded-lg font-medium border shadow-sm cursor-pointer transition-colors focus:outline-none focus:ring-1 focus:ring-black/20'
                                        style={{
                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
                                        }}>
                                        <option value=''>Choose Event Part</option>
                                        {sellerEventParts.split(';').map((p) => (
                                            <option key={p} value={p}>{p}</option>
                                        ))}
                                    </select>
                                )}

                                {/* Portion Size selector */}
                                {pt.productInfo.portionSizes && pt.productInfo.portionSizes !== '' && (
                                    <select
                                        value={pt.portionSize ?? ''}
                                        onChange={(e) => onPortionSizeChange(pt._id, e.target.value)}
                                        aria-label='Choose portion size'
                                        className='text-[12px] h-8 w-full max-w-[160px] px-2 rounded-lg font-medium border shadow-sm cursor-pointer transition-colors focus:outline-none focus:ring-1 focus:ring-black/20'
                                        style={{
                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight
                                        }}>
                                        <option value=''>Choose Portion Size</option>
                                        {pt.productInfo.portionSizes.split(';').map((p) => (
                                            <option key={p} value={p}>{p}</option>
                                        ))}
                                    </select>
                                )}

                            </div>
                        </div>
                    </div>

                    {/* BOTTOM GROUP — action buttons, always pinned to bottom by justify-between */}
                    <div className='flex flex-wrap gap-1.5 pt-1'>
                        <button
                            onClick={() => dispatch(delete_cart_product(pt._id))}
                            className='flex-1 min-w-[80px] py-1.5 text-[13px] font-medium flex justify-center items-center gap-1.5 text-white rounded-lg shadow-sm hover:opacity-90 hover:shadow-md active:scale-[0.98] transition-all duration-150'
                            style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            <FaTrash className='text-[11px]' /> Remove
                        </button>
                        <button
                            onClick={() => onMoveToWishlist(pt._id)}
                            className='flex-1 min-w-[100px] py-1.5 text-[13px] font-medium flex justify-center items-center gap-1.5 text-white rounded-lg shadow-sm hover:opacity-90 hover:shadow-md active:scale-[0.98] transition-all duration-150'
                            style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            <TbArrowBigRightLinesFilled /> Wishlist
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

CartProduct.propTypes = {
    pt: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        quantity: PropTypes.number,
        eventPart: PropTypes.string,
        portionSize: PropTypes.string,
        productInfo: PropTypes.shape({
            name: PropTypes.string,
            category: PropTypes.string,
            brand: PropTypes.string,
            byThePan: PropTypes.string,
            images: PropTypes.array,
            price: PropTypes.number,
            stock: PropTypes.number,
            portionSizes: PropTypes.string,
        }),
    }).isRequired,
    onQuantityIncrement: PropTypes.func.isRequired,
    onQuantityDecrement: PropTypes.func.isRequired,
    onPortionSizeChange: PropTypes.func.isRequired,
    onEventPartChange: PropTypes.func.isRequired,
    onMoveToWishlist: PropTypes.func.isRequired,
};

export default React.memo(CartProduct);







// import React from 'react';
// import PropTypes from 'prop-types';
// import { useDispatch } from 'react-redux';
// import { FaTrash } from "react-icons/fa6";
// import { TbArrowBigRightLinesFilled } from "react-icons/tb";
// import { currencyFormat } from './CurrencyFormat';
// import { delete_cart_product } from '../store/reducers/cartReducer';
// import SkeletonWithImage from './SkeletonWithImage';
// import GetSellerConfig from '../components/GetSellerConfig';

// import config from '../config';

// const CartProduct = ({
//     pt,
//     onQuantityIncrement,
//     onQuantityDecrement,
//     onPortionSizeChange,
//     onEventPartChange,
//     onMoveToWishlist,
// }) => {
//     const dispatch = useDispatch();
//     const sellerShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;

//     const {
//         sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight,
//         sellerEventParts, sellerBoolShowSitePayments, sellerBoolShowQuantities
//     } = GetSellerConfig();

//     // Precompute the repeated color combinations once
//     const colors = React.useMemo(() => ({
//         border: sellerPrimaryColor1 + sellerColorSuffixDark,
//         text: sellerPrimaryColor1 + sellerColorSuffixDark,
//         bg: sellerPrimaryColor1 + sellerColorSuffixLight,
//     }), [sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight]);

//     const hasPanLabel = pt?.productInfo?.byThePan !== 'NoPan';
//     const imageSrc = pt?.productInfo?.images?.[0];
//     const imageSizeStyle = { width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' };

//     return (
//         <div className='bg-white rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden 
//             border border-gray-700'
//             style={{
//                 backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                 // color: colorDark,
//                 borderLeft: `6px solid ${colors.border}`,
//                 borderColor: colors.border,
//             }}>
//             <div className='flex min-h-[210px]'>

//                 {/* Accent stripe — seller brand color */}
//                 <div
//                     className='hidden w-1.5 sm:w-2 shrink-0'
//                     style={{ backgroundColor: colors.border }}
//                     aria-hidden='true'
//                 />

//                 <div
//                     className='flex-1 p-3 flex flex-col gap-2.5 h-full'
//                     style={{
//                         color: colors.text,
//                         //backgroundColor: colors.bg,
//                     }}>

//                     {/* Name + category + byThePan — always at top */}
//                     <div className='flex flex-wrap items-start justify-between gap-1.5'>
//                         <div className='text-sm font-semibold leading-snug min-w-0 flex-1 tracking-tight'>
//                             <div>{pt?.productInfo?.name}</div>
//                             <div className='font-normal opacity-60'>{pt?.productInfo?.category}</div>
//                             {pt?.eventPart && (
//                                 <span
//                                     className='font-medium opacity-80 ml-1 px-2 py-0.5 rounded-full border text-[11px] shrink-0 inline-block'
//                                     style={{ borderColor: colors.border }}>
//                                     {pt.eventPart}
//                                 </span>
//                             )}
//                         </div>
//                         {hasPanLabel && (
//                             <div className='hidden sm:block'>
//                                 <div
//                                     className='border text-[11px] font-medium px-2.5 py-0.5 flex flex-wrap justify-center 
//                                     items-center rounded-md shrink-0 whitespace-nowrap shadow-sm'
//                                     style={{ borderColor: colors.border, backgroundColor: 'white' }}>
//                                     <span>{pt.productInfo.byThePan}</span>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Main row: image + controls side by side, wraps on tiny screens */}
//                     <div className='flex flex-wrap gap-3 flex-1'>
//                         {/* Image — fixed size wrapper collapses the skeleton's internal height */}
//                         <div className='shrink-0 overflow-hidden relative rounded-lg ring-1 ring-black/5 shadow-sm' style={imageSizeStyle}>
//                             <SkeletonWithImage
//                                 src={imageSrc}
//                                 alt={pt?.productInfo?.name}
//                                 className='rounded-lg object-cover'
//                                 style={imageSizeStyle}
//                             />
//                             {hasPanLabel && (
//                                 <div
//                                     className='sm:hidden absolute top-1.5 left-1 text-[10px] font-medium px-0.5 py-0.5 w-[88%] flex flex-wrap 
//                                     justify-center items-center border rounded-md shrink-0 shadow-sm'
//                                     style={{
//                                         borderColor: colors.border,
//                                         backgroundColor: 'white',
//                                         color: colors.text,
//                                     }}>
//                                     {pt.productInfo.byThePan}
//                                 </div>
//                             )}
//                             {sellerShowBrand && (
//                                 <div className='text-[11px] mt-1 opacity-60 truncate font-medium' style={{ maxWidth: 'clamp(80px, 20vw, 150px)' }}>
//                                     {pt.productInfo.brand}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Controls — fills remaining space, wraps internally 
//                             <div className='flex flex-col gap-2 flex-1 min-w-[120px]'>
//                             */}
//                         <div className='flex flex-col gap-2 flex-1 min-w-[120px] h-full'>

//                             {/* Price */}
//                             {sellerBoolShowSitePayments && (
//                                 <div className='text-base font-bold tracking-tight' style={{ color: colors.text }}>
//                                     {currencyFormat.format(pt.productInfo.price)}
//                                 </div>
//                             )}

//                             {/* Quantity stepper */}
//                             {sellerBoolShowQuantities && (
//                                 <div
//                                     className='flex h-8 w-full max-w-[160px] border rounded-lg justify-center items-center text-sm font-semibold select-none shadow-sm overflow-hidden'
//                                     style={{ 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                     }}>
//                                     <button
//                                         onClick={() => onQuantityDecrement(pt.quantity, pt._id)}
//                                         disabled={pt.quantity <= 1}
//                                         className='flex-1 h-full flex items-center justify-center cursor-pointer hover:bg-black/5 active:bg-black/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed'
//                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
//                                         aria-label='Decrease quantity'
//                                     >−</button>
//                                     <div className='px-3 border-x font-semibold' 
//                                         style={{ 
//                                             color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                             borderColor: sellerPrimaryColor1 + sellerColorSuffixDark 
//                                         }}>
//                                         {pt.quantity}
//                                     </div>
//                                     <button
//                                         onClick={() => onQuantityIncrement(pt.quantity, pt.productInfo.stock, pt._id)}
//                                         disabled={pt.quantity >= pt.productInfo.stock}
//                                         className='flex-1 h-full flex items-center justify-center cursor-pointer hover:bg-black/5 active:bg-black/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed'
//                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
//                                         aria-label='Increase quantity'
//                                     >+</button>
//                                 </div>
//                             )}

//                             {/* Event Part selector */}
//                             {sellerEventParts && sellerEventParts !== '' && (
//                                 <select
//                                     value={pt.eventPart ?? ''}
//                                     onChange={(e) => onEventPartChange(pt._id, e.target.value)}
//                                     aria-label='Choose event part'
//                                     className='text-[12px] h-8 w-full max-w-[160px] px-2 rounded-lg font-medium border shadow-sm cursor-pointer transition-colors focus:outline-none focus:ring-1 focus:ring-black/20'
//                                     style={{ 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                     }}>
//                                     <option value=''>Choose Event Part</option>
//                                     {sellerEventParts.split(';').map((p) => (
//                                         <option key={p} value={p}>{p}</option>
//                                     ))}
//                                 </select>
//                             )}

//                             {/* Portion Size selector */}
//                             {pt.productInfo.portionSizes && pt.productInfo.portionSizes !== '' && (
//                                 <select
//                                     value={pt.portionSize ?? ''}
//                                     onChange={(e) => onPortionSizeChange(pt._id, e.target.value)}
//                                     aria-label='Choose portion size'
//                                     className='text-[12px] h-8 w-full max-w-[160px] px-2 rounded-lg font-medium border shadow-sm cursor-pointer transition-colors focus:outline-none focus:ring-1 focus:ring-black/20'
//                                     style={{ 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                     }}>
//                                     <option value=''>Choose Portion Size</option>
//                                     {pt.productInfo.portionSizes.split(';').map((p) => (
//                                         <option key={p} value={p}>{p}</option>
//                                     ))}
//                                 </select>
//                             )}

//                             {/* Action buttons — row that wraps gracefully */}
//                             <div className='flex flex-wrap gap-1.5 mt-auto pt-1'>
//                                 <button
//                                     onClick={() => dispatch(delete_cart_product(pt._id))}
//                                     className='flex-1 min-w-[80px] py-1.5 text-[13px] font-medium flex justify-center items-center gap-1.5 text-white rounded-lg shadow-sm hover:opacity-90 hover:shadow-md active:scale-[0.98] transition-all duration-150'
//                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                     <FaTrash className='text-[11px]' /> Remove
//                                 </button>
//                                 <button
//                                     onClick={() => onMoveToWishlist(pt._id)}
//                                     className='flex-1 min-w-[100px] py-1.5 text-[13px] font-medium flex justify-center items-center gap-1.5 text-white rounded-lg shadow-sm hover:opacity-90 hover:shadow-md active:scale-[0.98] transition-all duration-150'
//                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                     <TbArrowBigRightLinesFilled /> Wishlist
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// CartProduct.propTypes = {
//     pt: PropTypes.shape({
//         _id: PropTypes.string.isRequired,
//         quantity: PropTypes.number,
//         eventPart: PropTypes.string,
//         portionSize: PropTypes.string,
//         productInfo: PropTypes.shape({
//             name: PropTypes.string,
//             category: PropTypes.string,
//             brand: PropTypes.string,
//             byThePan: PropTypes.string,
//             images: PropTypes.array,
//             price: PropTypes.number,
//             stock: PropTypes.number,
//             portionSizes: PropTypes.string,
//         }),
//     }).isRequired,
//     onQuantityIncrement: PropTypes.func.isRequired,
//     onQuantityDecrement: PropTypes.func.isRequired,
//     onPortionSizeChange: PropTypes.func.isRequired,
//     onEventPartChange: PropTypes.func.isRequired,
//     onMoveToWishlist: PropTypes.func.isRequired,
// };

// export default React.memo(CartProduct);





//refactored before redeisgn
// import React from 'react';
// import PropTypes from 'prop-types';
// import { useDispatch } from 'react-redux';
// import { FaTrash } from "react-icons/fa6";
// import { TbArrowBigRightLinesFilled } from "react-icons/tb";
// import { currencyFormat } from './CurrencyFormat';
// import { delete_cart_product } from '../store/reducers/cartReducer';
// import SkeletonWithImage from './SkeletonWithImage';
// import GetSellerConfig from '../components/GetSellerConfig';

// import config from '../config';

// const CartProduct = ({
//     pt,
//     onQuantityIncrement,
//     onQuantityDecrement,
//     onPortionSizeChange,
//     onEventPartChange,
//     onMoveToWishlist,
// }) => {
//     const dispatch = useDispatch();
//     const sellerShowBrand = config.BOOL_SHOW_PRODUCT_BRAND;

//     const {
//         sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight,
//         sellerEventParts, sellerBoolShowSitePayments, sellerBoolShowQuantities
//     } = GetSellerConfig();

//     // Precompute the repeated color combinations once
//     const colors = React.useMemo(() => ({
//         border: sellerPrimaryColor1 + sellerColorSuffixDark,
//         text: sellerPrimaryColor1 + sellerColorSuffixDark,
//         bg: sellerPrimaryColor1 + sellerColorSuffixLight,
//     }), [sellerPrimaryColor1, sellerColorSuffixDark, sellerColorSuffixLight]);

//     const hasPanLabel = pt?.productInfo?.byThePan !== 'NoPan';
//     const imageSrc = pt?.productInfo?.images?.[0];
//     const imageSizeStyle = { width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' };

//     return (
//         <div className='bg-white rounded-md'>
//             <div
//                 className='w-full border rounded-md p-2 flex flex-col gap-2'
//                 style={{
//                     borderColor: colors.border,
//                     color: colors.text,
//                     backgroundColor: colors.bg,
//                 }}>

//                 {/* Name + category + byThePan — always at top */}
//                 <div className='flex flex-wrap border-gray-700 items-start justify-between gap-1'>
//                     <div className='text-sm font-semibold leading-tight min-w-0 flex-1'>
//                         <span>{pt?.productInfo?.name}</span>
//                         <span className='font-normal opacity-70'>, {pt?.productInfo?.category}</span>
//                         {pt?.eventPart && (
//                             <span className='font-normal opacity-70 px-0.5 py-0.5 rounded-full border shrink-0'>
//                                 , {pt.eventPart}
//                             </span>
//                         )}
//                     </div>
//                     {hasPanLabel && (
//                         <div className='hidden sm:block'>
//                             <div
//                                 className='border text-xs px-1 py-0.5 flex flex-wrap justify-center items-center rounded-full shrink-0'
//                                 style={{ borderColor: colors.border }}>
//                                 <span>{pt.productInfo.byThePan}</span>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Main row: image + controls side by side, wraps on tiny screens */}
//                 <div className='flex flex-wrap gap-2'>
//                     {/* Image — fixed size wrapper collapses the skeleton's internal height */}
//                     <div className='shrink-0 overflow-hidden relative' style={imageSizeStyle}>
//                         <SkeletonWithImage
//                             src={imageSrc}
//                             alt={pt?.productInfo?.name}
//                             className='rounded object-cover'
//                             style={imageSizeStyle}
//                         />
//                         {hasPanLabel && (
//                             <div
//                                 className='sm:hidden absolute top-1 left-1 text-[11px] px-0.5 w-[94%] py-0.5 flex flex-wrap justify-center items-center border shrink-0'
//                                 style={{
//                                     borderColor: colors.border,
//                                     backgroundColor: 'white',
//                                     color: colors.text,
//                                 }}>
//                                 {pt.productInfo.byThePan}
//                             </div>
//                         )}
//                         {sellerShowBrand && (
//                             <div className='text-xs mt-1 opacity-70 truncate' style={{ maxWidth: 'clamp(80px, 20vw, 150px)' }}>
//                                 {pt.productInfo.brand}
//                             </div>
//                         )}
//                     </div>

//                     {/* Controls — fills remaining space, wraps internally */}
//                     <div className='flex flex-col gap-1.5 flex-1 min-w-[120px]'>

//                         {/* Price */}
//                         {sellerBoolShowSitePayments && (
//                             <div className='text-sm font-semibold' style={{ color: colors.text }}>
//                                 {currencyFormat.format(pt.productInfo.price)}
//                             </div>
//                         )}

//                         {/* Quantity stepper */}
//                         {sellerBoolShowQuantities && (
//                             <div
//                                 className='flex h-7 w-full max-w-[160px] border rounded-md justify-center items-center text-sm font-semibold select-none'
//                                 style={{ borderColor: colors.border, backgroundColor: colors.bg }}>
//                                 <button
//                                     onClick={() => onQuantityDecrement(pt.quantity, pt._id)}
//                                     disabled={pt.quantity <= 1}
//                                     className='flex-1 h-full flex items-center justify-center cursor-pointer rounded-l-md hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed'
//                                     style={{ color: colors.text }}
//                                     aria-label='Decrease quantity'
//                                 >−</button>
//                                 <div className='px-3 border-x' style={{ color: colors.text, borderColor: colors.border }}>
//                                     {pt.quantity}
//                                 </div>
//                                 <button
//                                     onClick={() => onQuantityIncrement(pt.quantity, pt.productInfo.stock, pt._id)}
//                                     disabled={pt.quantity >= pt.productInfo.stock}
//                                     className='flex-1 h-full flex items-center justify-center cursor-pointer rounded-r-md hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed'
//                                     style={{ color: colors.text }}
//                                     aria-label='Increase quantity'
//                                 >+</button>
//                             </div>
//                         )}

//                         {/* Event Part selector */}
//                         {sellerEventParts && sellerEventParts !== '' && (
//                             <select
//                                 value={pt.eventPart ?? ''}
//                                 onChange={(e) => onEventPartChange(pt._id, e.target.value)}
//                                 aria-label='Choose event part'
//                                 className='text-[12px] h-7 w-full max-w-[160px] px-1 rounded-md font-semibold border'
//                                 style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.bg }}>
//                                 <option value=''>Choose Event Part</option>
//                                 {sellerEventParts.split(';').map((p) => (
//                                     <option key={p} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {/* Portion Size selector */}
//                         {pt.productInfo.portionSizes && pt.productInfo.portionSizes !== '' && (
//                             <select
//                                 value={pt.portionSize ?? ''}
//                                 onChange={(e) => onPortionSizeChange(pt._id, e.target.value)}
//                                 aria-label='Choose portion size'
//                                 className='text-[12px] h-7 w-full max-w-[160px] px-1 rounded-md font-semibold border'
//                                 style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.bg }}>
//                                 <option value=''>Choose Portion Size</option>
//                                 {pt.productInfo.portionSizes.split(';').map((p) => (
//                                     <option key={p} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {/* Action buttons — row that wraps gracefully */}
//                         <div className='flex flex-wrap gap-1 mt-auto'>
//                             <button
//                                 onClick={() => dispatch(delete_cart_product(pt._id))}
//                                 className='flex-1 min-w-[80px] py-1 text-[13px] flex justify-center items-center gap-1 text-white rounded-md hover:opacity-80 transition-opacity'
//                                 style={{ backgroundColor: colors.border }}>
//                                 <FaTrash className='text-[11px]' /> Remove
//                             </button>
//                             <button
//                                 onClick={() => onMoveToWishlist(pt._id)}
//                                 className='flex-1 min-w-[100px] py-1 text-[13px] flex justify-center items-center gap-1 text-white rounded-md hover:opacity-80 transition-opacity'
//                                 style={{ backgroundColor: colors.border }}>
//                                 <TbArrowBigRightLinesFilled /> Wishlist
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// CartProduct.propTypes = {
//     pt: PropTypes.shape({
//         _id: PropTypes.string.isRequired,
//         quantity: PropTypes.number,
//         eventPart: PropTypes.string,
//         portionSize: PropTypes.string,
//         productInfo: PropTypes.shape({
//             name: PropTypes.string,
//             category: PropTypes.string,
//             brand: PropTypes.string,
//             byThePan: PropTypes.string,
//             images: PropTypes.array,
//             price: PropTypes.number,
//             stock: PropTypes.number,
//             portionSizes: PropTypes.string,
//         }),
//     }).isRequired,
//     onQuantityIncrement: PropTypes.func.isRequired,
//     onQuantityDecrement: PropTypes.func.isRequired,
//     onPortionSizeChange: PropTypes.func.isRequired,
//     onEventPartChange: PropTypes.func.isRequired,
//     onMoveToWishlist: PropTypes.func.isRequired,
// };

// export default React.memo(CartProduct);




//my original code
// import React from 'react';
// import { useDispatch } from 'react-redux';
// import { FaTrash } from "react-icons/fa6";
// import { TbArrowBigRightLinesFilled } from "react-icons/tb";
// import { currencyFormat } from './CurrencyFormat';
// import { delete_cart_product } from '../store/reducers/cartReducer';
// import SkeletonWithImage from './SkeletonWithImage';
// import GetSellerConfig from '../components/GetSellerConfig';

// import config from '../config';

// const CartProduct = ({
//     pt,
//     onQuantityIncrement,
//     onQuantityDecrement,
//     onPortionSizeChange,
//     onEventPartChange,
//     onMoveToWishlist,
// }) => {
//     const dispatch = useDispatch();
//     const sellerShowBrand = config.BOOL_SHOW_PRODUCT_BRAND

//     const { 
//         sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerEventParts, sellerBoolShowSitePayments, sellerBoolShowQuantities
//     } = GetSellerConfig();

//     return (
//         <div className='bg-white rounded-md' >
//             <div
//                 className='w-full border rounded-md p-2 flex flex-col gap-2 '
//                 style={{ 
//                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                     color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                 }}>
//                 {/* Name + category + byThePan — always at top */}
//                 <div className='flex flex-wrap -none border-gray-700 items-start justify-between gap-1'>
//                     <div className='text-sm font-semibold leading-tight min-w-0 flex-1'>
//                         <span> {pt?.productInfo?.name}</span>
//                         <span className='font-normal opacity-70'>, {pt?.productInfo?.category}</span>
//                         {pt?.eventPart && (
//                             <span className='font-normal opacity-70 px-0.5 py-0.5 rounded-full border shrink-0'>
//                             , {pt?.eventPart}
//                             </span>
//                         )}
//                     </div>
//                     {
//                         pt.productInfo.byThePan !== 'NoPan' && (
//                         <div className='hidden sm:block'>
//                             <div
//                                 className='border text-xs px-1 py-0.5 flex flex-wrap justify-center items-center rounded-full  shrink-0'
//                                 style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                 <span  >{pt.productInfo.byThePan}</span>
//                             </div>
//                         </div>)
//                     }
//                 </div>

//                 {/* Main row: image + controls side by side, wraps on tiny screens */}
//                 <div className='flex flex-wrap gap-2'>
//                     {/* Image — shrinks fluidly, never overflows */}
//                     {/* Image — fixed size wrapper collapses the skeleton's internal height */}
//                     <div className='shrink-0 overflow-hidden relative' style={{ width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' }}>
//                         <SkeletonWithImage
//                             src={pt.productInfo.images[0]}
//                             alt={pt.productInfo.name}
//                             className='rounded object-cover'
//                             style={{ width: 'clamp(80px, 20vw, 150px)', height: 'clamp(60px, 15vw, 110px)' }}
//                         />
//                         {/* m-1 border w-[97%] absolute top-0 left-0 text-center */}
//                         {pt.productInfo.byThePan !== 'NoPan' && (
//                             <div className='bg-white'>
//                                 <div
//                                     className='sm:hidden absolute top-1 left-1 text-[11px] px-0.5 w-[94%] py-0.5 flex flex-wrap justify-center items-center border shrink-0'
//                                     style={{ 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         backgroundColor: 'white', // sellerPrimaryColor1 + sellerColorSuffixLight, 
//                                         color: sellerPrimaryColor1 + sellerColorSuffixDark 
//                                     }}>
//                                     {pt.productInfo.byThePan}
//                                 </div>
//                             </div>
//                         )}
//                         {sellerShowBrand && (
//                             <div className='text-xs mt-1 opacity-70 truncate' style={{ maxWidth: 'clamp(80px, 20vw, 150px)' }}>
//                                 {pt.productInfo.brand}
//                             </div>
//                         )}
//                     </div>
                
//                     {/* Controls — fills remaining space, wraps internally */}
//                     <div className='flex flex-col gap-1.5 flex-1 min-w-[120px]'>

//                         {/* Price */}
//                         {sellerBoolShowSitePayments && (
//                             <div className='text-sm font-semibold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                 {currencyFormat.format(pt.productInfo.price)}
//                             </div>
//                         )}

//                         {/* Quantity stepper */}
//                         {sellerBoolShowQuantities && (
//                             <div
//                                 className='flex h-7 w-full max-w-[160px] border rounded-md justify-center items-center text-sm font-semibold select-none'
//                                 style={{ 
//                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                 }}>
//                                 <button
//                                     onClick={() => onQuantityDecrement(pt.quantity, pt._id)}
//                                     className='flex-1 h-full flex items-center justify-center cursor-pointer rounded-l-md hover:opacity-70 transition-opacity'
//                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
//                                     aria-label='Decrease quantity'
//                                 >−</button>
//                                 <div className='px-3 border-x' 
//                                     style={{ 
//                                         color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark 
//                                     }}>
//                                     {pt.quantity}
//                                 </div>
//                                 <button
//                                     onClick={() => onQuantityIncrement(pt.quantity, pt.productInfo.stock, pt._id)}
//                                     className='flex-1 h-full flex items-center justify-center cursor-pointer rounded-r-md hover:opacity-70 transition-opacity'
//                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
//                                     aria-label='Increase quantity'
//                                 >+</button>
//                             </div>
//                         )}

//                         {/* Event Part selector */}
//                         {sellerEventParts && sellerEventParts !== '' && (
//                             <select
//                                 defaultValue={pt.eventPart ?? ''}
//                                 onChange={(e) => onEventPartChange(pt._id, e.target.value)}
//                                 className='text-[12px] h-7 w-full max-w-[160px] px-1 rounded-md font-semibold border'
//                                 style={{ 
//                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                 }}>
//                                 <option value=''>Choose Event Part</option>
//                                 {sellerEventParts.split(';').map((p, i) => (
//                                     <option key={i} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {/* Portion Size selector */}
//                         {pt.productInfo.portionSizes && pt.productInfo.portionSizes !== '' && (
//                             <select
//                                 defaultValue={pt.portionSize ?? ''}
//                                 onChange={(e) => onPortionSizeChange(pt._id, e.target.value)}
//                                 className='text-[12px] h-7 w-full max-w-[160px] px-1 rounded-md font-semibold border'
//                                 style={{ 
//                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     color: sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                 }}>
//                                 <option value=''>Choose Portion Size</option>
//                                 {pt.productInfo.portionSizes.split(';').map((p, i) => (
//                                     <option key={i} value={p}>{p}</option>
//                                 ))}
//                             </select>
//                         )}

//                         {/* Action buttons — row that wraps gracefully */}
//                         <div className='flex flex-wrap gap-1 mt-auto'>
//                             <button
//                                 onClick={() => dispatch(delete_cart_product(pt._id))}
//                                 className='flex-1 min-w-[80px] py-1 text-[13px] flex justify-center items-center gap-1 text-white rounded-md hover:opacity-80 transition-opacity'
//                                 style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                 <FaTrash className='text-[11px]' /> Remove
//                             </button>
//                             <button
//                                 onClick={() => onMoveToWishlist(pt._id)}
//                                 className='flex-1 min-w-[100px] py-1 text-[13px] flex justify-center items-center gap-1 text-white rounded-md hover:opacity-80 transition-opacity'
//                                 style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                 <TbArrowBigRightLinesFilled /> Wishlist
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CartProduct;





